import { createContext, useContext } from "react";
import type { FormState } from "../core/types/tsx/pages/ServiceRequestWizard.types";

type PendingHireItem = {
	id: number;
	name: string;
	price: number;
	quantity: number;
};

export type PendingHirePayload = {
	providerId: number;
	providerName?: string;
	selectedAddressId: number;
	selectedItems: PendingHireItem[];
	subtotal: number;
};

export type RegistrationWizardData = {
	paymentMethod: string;
	paymentReference: string;
	paymentBankIssuer: string;
	couponCode: string;
	couponId: number | null;
	couponDiscountPercent: number;
	acceptedTerms: boolean;
};

export type ServiceRegistrationWizardContextValue = {
	wizardData: RegistrationWizardData;
	updateWizardData: (patch: Partial<RegistrationWizardData>) => void;
	resetWizardData: () => void;
	isWizardComplete: boolean;
	serviceRequestData: FormState;
	setServiceRequestData: (next: FormState) => void;
	updateServiceRequestData: (patch: Partial<FormState>) => void;
	resetServiceRequestData: () => void;
	isServiceRequestComplete: boolean;
	pendingHirePayload: PendingHirePayload | null;
	setPendingHirePayload: (payload: PendingHirePayload | null) => void;
};

export const initialWizardData: RegistrationWizardData = {
	paymentMethod: "",
	paymentReference: "",
	paymentBankIssuer: "",
	couponCode: "",
	couponId: null,
	couponDiscountPercent: 0,
	acceptedTerms: false,
};

export const initialServiceRequestData: FormState = {
	urgency: "",
	location: {
		nombreDireccion: "",
		direccion: "",
		referencias: "",
	},
	schedule: {
		date: "",
		time: "",
		period: "AM",
	},
	category: "",
	categoryId: undefined,
	subcategory: [],
};

export const ServiceRegistrationWizardContext =
	createContext<ServiceRegistrationWizardContextValue | null>(null);

export function useServiceRegistrationWizard() {
	const context = useContext(ServiceRegistrationWizardContext);
	if (!context) {
		throw new Error(
			"useServiceRegistrationWizard must be used inside ServiceRegistrationWizardProvider",
		);
	}
	return context;
}
